import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useSaleOrderModel } from "../saleOrderModel";
import { SettleScaniaPrints } from "./settleScaniaPrints";
import { SalePrint } from "./SalePrint";

export default () => {
    const {
        print,
        settleScaniaPrint
    } = useSaleOrderModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            {print && <SalePrint />}
            {settleScaniaPrint && <SettleScaniaPrints />}
        </>
    )
}